import React, { useEffect, useState } from 'react';

import './App.scss';
import { GamePage } from './pages/GamePage';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { useEnv } from './hooks/useEnv';
import { Header } from './components/header/Header';
import { RootState } from './redux/reducers';

export let dispatch: Dispatch;
function App() {

  dispatch = useDispatch();
  useEnv();

  const [darkMode, setDarkMode] = useState<boolean>(true);
  const [theme, setTheme] = useState<string>('dark');

  useSelector((state: RootState) => {
    if(state.system.themeDark !== darkMode) {
      setDarkMode(state.system.themeDark);
    }
  });


  useEffect(() => {
    if (darkMode === false) {
      setTheme('light');
      return;
    }

    setTheme('dark');
  }, [darkMode]);

  
  return (
    <div className="App" data-bs-theme={theme}>
      <Header></Header>
      <GamePage></GamePage>
    </div>
  );
}

export default App;
